<template>
  <div class="page">
    <Share :data="shareData"></Share>
    <common-text :data="CommonText0"></common-text>
  </div>
</template>

<script>
import Share from '../../components/share.vue'
/* eslint-disable */
export default {
  data() {
    return {
      CommonText0: {"context":"<p class=\"ql-align-center\"><strong>鲸小胖接入第三方SDK目录</strong></p><p>\t为保障鲸小胖App相关功能的实现与应用的稳定运行，我们可能会接入由第三方提供的软件开发包（SDK）实现前述目的。我们会不时对该等合作伙伴或服务提供商进行技术检测和行为审计，并要求其遵循合作法律协议，以最大限度地确保其依法、依规、依约收集和使用数据。我们的产品接入第三方SDK具体情形如下：</p><p><strong>1、&nbsp;TBS腾讯浏览</strong></p><p><strong>使用目的和支持的业务功能：</strong>网页浏览</p><p><strong>涉及个人信息：</strong>设备信息、网络信息、日志信息、设备型号、android_id、IMEI、IMSI、bssid</p><p><strong>第三方机构名称：</strong>深圳市腾讯计算机系统有限公司</p><p><strong>隐私政策地址：</strong><a href=\"https://x5.tencent.com/tbs/guide/develop.html\" target=\"_blank\">https://x5.tencent.com/tbs/guide/develop.html</a></p><p><strong>2、Chromium SDK</strong></p><p><strong>使用目的和支持的业务功能：</strong>网页容器用于辅助开发</p><p><strong>涉及个人信息</strong>：设备版本、IMSI、设备安装列表、网络设备制造商、MAC地址、Wifi信息、ssid</p><p><strong>收集方式：</strong>SDK本机采集、不涉及数据共享</p><p><strong>第三方机构名称：</strong>Google&nbsp;Inc</p><p><strong>隐私政策地址：</strong><a href=\"https://policies.google.cn/\" target=\"_blank\">https://policies.google.cn/</a></p><p><strong>3、Okhttp&nbsp;SDK</strong></p><p><strong>使用目的和支持的业务功能：</strong>网络请求</p><p><strong>涉及个人信息</strong>：AndroidId、IMEI、MAC地址</p><p><strong>收集方式：</strong>SDK本机采集、不涉及数据共享</p><p><strong>第三方机构名称：</strong>Square</p><p><strong>隐私政策地址</strong>：https://github.com/square/okhttp</p>","style":{"backgroundColor":"#fff","position":"static","top":0,"left":0,"width":"","height":"","borderRadius":"0px","margin":"0px","padding":"0px"}},
      shareData: {"title":"鲸小胖接入第三方SDK目录","bgColor":"#fff","padding":"10px","bgSize":"100%","bgImage":"","sdDataBiz":"cf","sdDataAppKey":"","useSdAccount":true,"userThirdScope":"base","thirdType":17,"shareDataFrom":"fixed","shareApi":{"method":"GET","url":"","data":[{"type":"url","key":"","value":""}],"response":{"shareTitle":{"type":"api","value":""},"shareDesc":{"type":"api","value":""},"shareImg":{"type":"api","value":""},"shareLink":{"type":"api","value":""}}},"shareTitle":"分享标题分享标题分享标题","shareDesc":"分享描述分享描述分享描述分享描述分享描述分享描述分享描述分享描述","shareImg":"https://store.sdbao.com/luban/comoponent-1553071553435.png","shareLink":"","channel_id":"","queryString":"","bi_pageid":"","bi_custom_params":{"project_id_luban":"7zh68jbn8c3n"}}
    }
  },
  components: {
    Share
  }
}
</script>

<style scoped>
.page {
  background-color: #fff;
  background-image: url();
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 10px;
}
</style>
